export enum DIALOG_TYPES {
  EDIT,
  UPGRADE,
  DELETE,
  ROTATE_CA,
  NODEGROUP_ADD,
  NODEGROUP_EDIT,
  NODEGROUP_DELETE,
  NODEGROUP_RESIZE,
  NODEGROUP_AUTOSCALE,
  NODEGROUP_UPGRADE
}

export enum TABS {
  NODES,
  NODE_POOLS,
  SETTINGS,
  MISCELLANEOUS,
  LABELS
}
